export const getQueryKey = () => ['userProfile'];
